import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import prettyExpression from 'ui-library/charting/statistics/regression/prettyExpression';
import {RegressionAnalysisResult} from 'ui-library/charting/statistics/regression/RegressionTypes';
import {GRAY_DARKER} from 'ui-library/Colors';
import CopyButton from 'ui-library/CopyButton';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import {Title} from 'ui-library/Headers';
import {Column, Table} from 'ui-library/simple-table/SimpleTable';
import * as ExportUtil from 'util/ExportUtil';

export default function RegressionOutputTooltipContent({
  regressionResult: {outputValues, tooltipDisclaimer},
}: {
  regressionResult: RegressionAnalysisResult<unknown>;
}): JSX.Element {
  const clipboardContent = ExportUtil.formatRows(
    [outputValues.map((val) => val.fieldName), outputValues.map((val) => val.value.toString())],
    '\t'
  );

  return (
    <div className={css(styles.wrapper)}>
      <div className="u-lr-split">
        <Title>Regression values</Title>
        <Tooltip text="Copy values" disableContentSelection={true}>
          <CopyButton
            size={ButtonSize.SMALL}
            value={clipboardContent}
            buttonStyle={ButtonStyle.CIRCLE_ICON}
          />
        </Tooltip>
      </div>
      <Table
        numRows={outputValues.length}
        isCompact={true}
        // A combination of the table border with the first row's box shadow made the top border of the
        // table thicker than the other borders. Removing the first row's box shadow avoids that issue.
        getRowClassName={(index) => (index === 0 ? css(styles.noBoxShadow) : '')}
      >
        <Column
          renderCell={(index) =>
            outputValues[index].fieldNameDisplayOverride ?? outputValues[index].fieldName
          }
        />
        <Column renderCell={(index) => prettyExpression(outputValues[index].value, null)} />
      </Table>
      <span className={css(styles.disclaimerWrapper)}>{tooltipDisclaimer}</span>
    </div>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    width: 190,
  },
  disclaimerWrapper: {
    color: GRAY_DARKER,
  },
  noBoxShadow: {
    boxShadow: 'none',
  },
});
